/** @format */

import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import {
	AppProductReviewState,
	selectProductReviewProductIdentifier
} from '@product-reviews/data-access';

@Component({
    selector: 'product-reviews-questions-answers',
    templateUrl: './review-questions-and-answers.component.html',
    styleUrls: ['./review-questions-and-answers.component.scss'],
    standalone: false
})
export class ReviewQuestionsAndAnswersComponent {
	/**
	 *
	 * @description
	 * Product Id - Bazaar voice uses this identifier to display the correct reviews
	 */
	productIdentifier$ = this.store.select(selectProductReviewProductIdentifier);

	constructor(private store: Store<AppProductReviewState>) {}
}
